module.exports = __webpack_public_path__ + "img/selected6-min.4ea27fb4.png";